import React from 'react';
import styled from 'styled-components';

import { PAYMENT_DECLINE_FALLBACK_MESSAGE } from '~/api/finance/financeApiTypes';
import { Button } from '~/atomic/atom/Button';
import { PageTitleStyle, TextRegStyle } from '~/atomic/Typography';

interface ErrorProps {
  error?: any;
  onClose?: () => void;
}

export const Error: React.FC<ErrorProps> = ({ error, onClose }) => {
  return (
    <SCError>
      <SCTitle>Банк не смог выполнить платеж</SCTitle>
      <SCMain>
        <SCText>
          Причина:
          {' '}
          {error || PAYMENT_DECLINE_FALLBACK_MESSAGE}
        </SCText>
      </SCMain>
      <SCText>Попробуйте повторить и выберите другой способ оплаты.</SCText>
      {onClose && (
        <SCCloseButton
          onClick={onClose}
          size="large"
          type="primary"
        >
          Закрыть
        </SCCloseButton>
      )}
    </SCError>
  );
};

const SCError = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 15px;
  text-align: center;
`;

const SCTitle = styled.h2`
  ${PageTitleStyle};
  margin-top: 10px;
`;

const SCText = styled.span`
  ${TextRegStyle};
  color: var(--black-color)
`;

const SCMain = styled.div`
  margin-top: 15px;
  margin-bottom: 27px;
  display: flex;
  flex-direction: column;
  align-items: center
`;

const SCCloseButton = styled(Button)`
  margin-top: 24px;
  min-width: 160px;
  height: 50px;
  border-radius: 12px;
  font-size: 18px;
  font-weight: 600;
`;
